import { Injectable } from '@angular/core';
import { Functions } from '@angular/fire/functions';
import { IObjectKey } from '@nova/common-interfaces';
import { FUNCTION_NAME, IHandhole } from '@rfm/shared-interfaces';
import { CommonService } from '../../../../lib/services/index.mjs';

@Injectable({
  providedIn: 'root',
})
export class HandholeService extends CommonService<IHandhole, IObjectKey> {
  public override deleteFunctionName: FUNCTION_NAME = FUNCTION_NAME.FIBERMANAGEMENT_HANDHOLE_REMOVE;
  public override mergeFunctionName: FUNCTION_NAME = FUNCTION_NAME.FIBERMANAGEMENT_HANDHOLE_MERGE;
  public override updateFunctionName: FUNCTION_NAME = FUNCTION_NAME.FIBERMANAGEMENT_HANDHOLE_UPDATE;
  public override getKeysFunctionName: FUNCTION_NAME = FUNCTION_NAME.FIBERMANAGEMENT_HANDHOLE_GETKEYS;
  override getFunctionName: FUNCTION_NAME = FUNCTION_NAME.FIBERMANAGEMENT_HANDHOLE_GET;
  override getAllFunctionName: FUNCTION_NAME = FUNCTION_NAME.FIBERMANAGEMENT_HANDHOLE_GETALL;
  override insertFunctionName: FUNCTION_NAME = FUNCTION_NAME.FIBERMANAGEMENT_HANDHOLE_INSERT;

  constructor(functions: Functions) {
    super(functions);
  }
}
